import styled from 'styled-components';
import { theme, palette } from 'styled-tools';

export const Container = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  margin-top: 40px;
`;

export const SubContainer = styled.div`
  max-width: 800px;
  h1 {
    font-size: 30px;
    font-weight: bold;
    margin-bottom: 12px;
  }
  h2 {
    font-size: 24px;
    font-weight: bold;
    margin-bottom: 12px;
  }
  h3 {
    font-size: 18px;
    font-weight: bold;
    margin-bottom: 12px;
  }
  p {
    margin-bottom: 10px;
  }
`;

export const PlanDetailsContainer = styled.div`
  margin-top: 32px;
  padding: 12px;
  border: 1px solid ${palette('borderInput')};
  border-radius: ${theme('borderRadius.sm')};
`;

export const StripeBadge = styled.img`
  max-width: 100px;
  float: right;
`;

export const PlanDetailsRow = styled.div`
  display: flex;
  margin-bottom: 32px;
  gap: 80px;
`;

type LozengeProperties = {
  readonly isActive: boolean;
};

export const Lozenge = styled.div<LozengeProperties>`
  font-size: ${theme('fontSize.xxs')};
  font-weight: bold;
  display: inline-block;
  text-align: center;
  text-transform: uppercase;
  padding: 4px 12px;
  margin: 0 8px;
  color: white;
  vertical-align: middle;
  background-color: ${(props) =>
    props.isActive ? palette('badgeDone') : palette('danger')};
  border-radius: ${theme('borderRadius.sm')};
  ${theme('components.StatusBadge')}
`;
